/* eslint-disable quotes */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import logo from '../../../../assets/Logo@3x.png';
import { headerNoAuth } from '../../../../services/API/apiConfig';

import { retrieveCompanyName } from '../../../../services/routerPagesManager/routerPagesManager';
import {
  LogoStyled,
  RootStyled,
  TextStyled,
  NewTokenBtn,
} from './Verification.style';

const companyName = retrieveCompanyName();

const Verification = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [expired, setExpired] = useState(false);

  const generateNewToken = () => {
    navigate('/resend_email');
  };

  useEffect(() => {
    setLoading(true);
    const queryParameters = new URLSearchParams(window.location.search);
    setToken({ token: queryParameters.get('token') });
  }, []);

  if (token.token) {
    axios
      .post(
        `https://${companyName}.sioon.com.br:3000/api/users/verification`,
        token,
        {
          headers: headerNoAuth(),
        }
      )
      .then(() => {
        setSuccess(true);
        setTimeout(() => {
          navigate('/login');
        }, 2500);
      })
      .catch(({ response }) =>
        response.data.messages === 'Token expirou.'
          ? setExpired(true)
          : setError(true)
      )
      .finally(() => {
        setLoading(false);
      });
  }

  if (loading) {
    return (
      <RootStyled>
        <LogoStyled src={logo} alt="Logo de Sioon" />
        <TextStyled>
          Aguarde um momento enquanto confirmamos sua conta.
        </TextStyled>
      </RootStyled>
    );
  }

  return (
    <RootStyled>
      {expired && (
        <>
          <TextStyled>
            O link que você acessou expirou. Para continuar, clique no botão
            abaixo para receber um novo e-mail de ativação da sua conta.
          </TextStyled>
          <NewTokenBtn variant="contained" onClick={generateNewToken}>
            Gerar link
          </NewTokenBtn>
        </>
      )}
      {error && (
        <TextStyled>
          Parece que algo deu errado, por favor entre em contato com nossa
          equipe
        </TextStyled>
      )}
      {success && (
        <TextStyled>
          Conta verificada com sucesso, redirecionando para o login
        </TextStyled>
      )}
    </RootStyled>
  );
};

export default Verification;
